import InboxIcon from '@mui/icons-material/Inbox';

import { Button } from '@/components/ui/Button';
import { EmptyState } from '@/components/ui/EmptyState';

import { State } from '../State';

export function EmptyStateExamples() {
  return (
    <>
      <State title="A sentence" note="What a list shows when nothing exists yet.">
        <EmptyState title="No campaigns yet." testId="gallery-empty-state-plain" />
      </State>

      <State
        title="With a second line and a way forward"
        note="The action is the caller's own button or link."
      >
        <EmptyState
          title="No campaigns yet."
          description="Create the first one and it will appear here."
          action={
            <Button
              variant="secondary"
              size="sm"
              data-testid="gallery-empty-state-action-button"
            >
              New campaign
            </Button>
          }
          testId="gallery-empty-state-with-action"
        />
      </State>

      <State
        title="With a decorative icon"
        note="Hidden from a screen reader; the sentence carries the meaning."
      >
        <EmptyState
          icon={<InboxIcon />}
          title="Nothing matched your search."
          description="Clear the filters to see every campaign."
          testId="gallery-empty-state-with-icon"
        />
      </State>
    </>
  );
}
